<template>
    <div class="container">
        <div class="row" v-show="!loading">
            <div class="col-12">
                <br />
                <br />
                <br />
                <br />
                <br />
                <h5 class="text-center">Sorry, that page isn't here.</h5>
                <br />
                <p class="text-center">
                    You didn't do anything wrong. We may have moved the page you're looking for somewhere else.
                </p>
                <br />
                <h6 class="text-center"><router-link to="/">Head back home.</router-link></h6>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "NotFound",
    computed: {
        loading() {
            return this.$store.getters.loading
        },
    }
}
</script>